exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header.scrollup[data-v-9487626a]{transform:translateY(-36px)}header.scrollup .usp-bar .row>div[data-v-9487626a]{opacity:0}@media screen and (max-width:768px){header .logo[data-v-9487626a]{width:auto;height:25px}}", ""]);

// exports
